<template>
  <v-dialog :value="value" @input="$emit('input')" max-width="400px" persistent>
    <v-card>
      <v-card-title class="title">
        Assign Campaign to the Post
      </v-card-title>
      <v-card-text class="body-2">
        <p v-if="postData !== null">
          Inputted name from Creator: <span class="font-italic">{{postData.campaignName}}</span>
        </p>
        <v-autocomplete
          :items="campaignList"
          label="Choose Campaigns in IMS:"
          item-value="id"
          item-text="name"
          v-model="selectedCampaignID"
        ></v-autocomplete>
      </v-card-text>
      <v-card-actions>        
        <v-btn color="red" text @click.native="$emit('input')">Close</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="green" text @click="assignCampaign()">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import config from '@/config';
import campaignAPIs from '../Campaign/campaignAPIs';
import postAPIs from './postApi';

export default {
  props: {
    value: Boolean,
    post: Object
  },
  data () {
    return {
      postData: null,
      campaignList: null,
      selectedCampaignID: null
    }
  },
  mounted() {
    this.fetchCampaignList()
  },
  methods: {
    assignCampaign() {
      postAPIs.csAssignCampaign(this.postData._id, this.selectedCampaignID)
        .then(response => {
          this.$emit('input')
          this.$swal({
            title: 'Saved Changes',
            content: 'Page will reload to apply changes',
            type: 'success'
          }).then(() => this.$emit('success'))
        })
        .catch(err => {
          this.$swal({
            position: 'top-end',
            title: `Can't Save Changes`,
            text: err,
            type: 'error'
          })
        })
    },
    fetchCampaignList() {
      campaignAPIs.getAllCampaignsNoStatus()
        .then(response => {
          let results = []
          response = response.filter(r => r.status === config.campaignStatus.ONGOING || r.status === config.campaignStatus.PAIRING_INFLUENCER)
          response.forEach(element => {
            let campaign = {
              name: element.name,
              id: element.id
            }
            results.push(campaign)
          });
          this.campaignList = results
        })
        .catch(err => {
          console.log('Error:' + err)
          console.log('')
        })
    }
  },
  watch: {
    post(newPost) {
      if (newPost !== null) {
        this.postData = newPost
        this.selectedCampaignID = this.postData.campaignID || null
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// AssignCampaignModal.vue?625bdd2d